import { Redirect } from 'expo-router';

import { isRbiOrderExpired } from 'pages/cart/payment/order-payment/is-rbi-order-id-expired';
import { Payment } from 'pages/cart/payment/order-payment/payment';
import { useCartContext } from 'state/cart';
import { routes } from 'utils/routing';

export default function CartPaymentPage() {
  const isRbiOrderIdValid = useRbiOrderIdExpirationCheck();

  if (!isRbiOrderIdValid) {
    return <Redirect href={routes.cart} />;
  }

  return <Payment />;
}

function useRbiOrderIdExpirationCheck(): boolean {
  const { rbiOrderId, setRbiOrderId } = useCartContext();
  return isRbiOrderExpired(rbiOrderId, setRbiOrderId);
}
